import Select from "react-select";
import React from "react";
const customStyle = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? "#888D93" : "#888D93",
    // boxShadow: state.isFocused ? "0px 0px 6px #888D93" : "none",
    "&:hover": {
      borderColor: "#888D93",
    },
  }),
  menu: (provided) => ({
    ...provided,
    padding: 0,
  }),

  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    textAlign: "left",
    color: "#DDDFE0",
    fontFamily: "'Outfit', sans-serif",
    fontSize: "14px",
    fontWeight: 300,
  }),
  option: (provided, state) => ({
    ...provided,
    color: "rgba(0, 0, 0, 0.5)",
    backgroundColor: state.isSelected
      ? "rgba(224, 233, 237, 0.8)"
      : "transparent",
    fontSize: "14px",
    fontWeight: "400",
    textAlign: "start",
    ":active": {
      backgroundColor: "rgba(224, 233, 237, 0.8)",
    },
    ":hover": {
      backgroundColor: "rgba(224, 233, 237, 0.8)",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "rgba(0, 0, 0, 0.7)",
    fontSize: "14px",
    fontWeight: "300",
    textAlign: "start",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#888D93",
  }),
};

const ReactSelect = ({
  value,
  handleOnChange,
  isSearchable,
  options,
  name,
  isLoading,
  loadingMessage,
  noOptionsMessage,
  placeholder,
  selectInputRef,
  multiple,
  classNamePrefix,
  id,
  isClearable = false,
  defaultValue = {},
}) => {
  return (
    <Select
      isMulti={multiple && multiple !== undefined ? true : false}
      ref={selectInputRef ? selectInputRef : null}
      styles={customStyle}
      value={value}
      placeholder={placeholder}
      onChange={(selectedOption) => {
        if (selectedOption !== null) {
          handleOnChange(name, selectedOption);
        } else {
          handleOnChange(name, null);
        }
      }}
      isSearchable={isSearchable}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option._id}
      options={options}
      name={name}
      isLoading={isLoading}
      loadingMessage={() => loadingMessage}
      noOptionsMessage={() => noOptionsMessage}
      isClearable={isClearable ? value !== null : false}
      classNamePrefix={classNamePrefix}
      id={id}
      valueType={"string"}
      defaultValue={defaultValue}
    />
  );
};

export { ReactSelect, customStyle };
